<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense  dark color="primary">
          <v-toolbar-title>{{$t("view.sucursal.title")}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list dense subheader>
            <v-subheader>{{$t("view.comercio.form")}}</v-subheader>
              <v-list-tile>
                <v-list-tile-content >
                  <v-list-tile-title>{{$t("view.global.common.clave")}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{comercio.clave}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content >
                  <v-list-tile-title>{{$t("view.comercio.name")}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{comercio.name}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content >
                  <v-list-tile-title>{{$t('view.comercio.numeroComercio')}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{comercio.numeroComercio}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
          </v-list>
          <v-spacer/>
          <sucursal ref="sucursalForm" :comercio="comercio"></sucursal>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" flat @click.native="dialog = false">Disagree</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false">Agree</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Sucursal from "@/views/generales/comercio/Sucursal";

export default {
  data() {
    return {
      dialog : false
      , comercio : null
    }
  }
  ,methods: {
    openDialog(comercio){
      this.dialog = true;
      this.comercio = comercio;
    }
  }
  , components: {
    Sucursal
    // , DataTable
    // , Auditoria 
  } 
}
</script>


// WEBPACK FOOTER //
// src/views/generales/comercio/ModalSucursal.vue